<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  @if (message) {
  <div class="row">
    <div class="col">
      {{ message }}
    </div>
  </div>
  }

  <div class="field">
    <label>Comment</label>
    <textarea
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="15"
      cdkAutosizeMaxRows="20"
      [(ngModel)]="comment"
    ></textarea>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="confirm()" [disabled]="isConfirmDisabled()" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
